import { IconButton, Tooltip, useToggle } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { CardTransactionColumnSettingModal } from './CardTransactionMenuFilterModal';

export const CardTransactionSettings = () => {
  const { t } = useTranslation();
  const [isMenuOpen, toggleMenu] = useToggle(false);

  return (
    <div className="flex items-center justify-between w-fit">
      <Tooltip messageContent={t('pages.cores.organizeModalTitle')}>
        <IconButton
          icon="settings"
          variant="secondary"
          data-testid="organize-operations-table-btn"
          onClick={toggleMenu}
        />
      </Tooltip>

      <CardTransactionColumnSettingModal
        title={t('pages.cores.organizeModalTitle')}
        onClose={toggleMenu}
        isModalOpen={isMenuOpen}
      />
    </div>
  );
};
